/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccessDeniedErrorResponse,
  BadRequestErrorResponse,
  BankAccountApiResource,
  ConflictErrorResponse,
  CreateOwnerRequest,
  GetApiOwnerList200,
  GetApiOwnerListParams,
  NotFoundErrorResponse,
  OwnerApiResource,
  UnauthorizedErrorResponse,
  UpdateOwnerRequest
} from '.././models';

import { customFetch } from '../../custom-fetch';

export type deleteApiOwnerArchiveResponse204 = {
  data: void
  status: 204
}

export type deleteApiOwnerArchiveResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type deleteApiOwnerArchiveResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type deleteApiOwnerArchiveResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type deleteApiOwnerArchiveResponseSuccess = (deleteApiOwnerArchiveResponse204) & {
  headers: Headers;
};
export type deleteApiOwnerArchiveResponseError = (deleteApiOwnerArchiveResponse401 | deleteApiOwnerArchiveResponse403 | deleteApiOwnerArchiveResponse404) & {
  headers: Headers;
};

export type deleteApiOwnerArchiveResponse = (deleteApiOwnerArchiveResponseSuccess | deleteApiOwnerArchiveResponseError)

export const getDeleteApiOwnerArchiveUrl = (id: number,) => {


  

  return `/api/owners/${id}/archive`
}

export const deleteApiOwnerArchive = async (id: number, options?: RequestInit): Promise<deleteApiOwnerArchiveResponse> => {
  
  return customFetch<deleteApiOwnerArchiveResponse>(getDeleteApiOwnerArchiveUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}


export type getApiOwnerBankAccountsListResponse200 = {
  data: BankAccountApiResource[]
  status: 200
}

export type getApiOwnerBankAccountsListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiOwnerBankAccountsListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getApiOwnerBankAccountsListResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type getApiOwnerBankAccountsListResponseSuccess = (getApiOwnerBankAccountsListResponse200) & {
  headers: Headers;
};
export type getApiOwnerBankAccountsListResponseError = (getApiOwnerBankAccountsListResponse401 | getApiOwnerBankAccountsListResponse403 | getApiOwnerBankAccountsListResponse404) & {
  headers: Headers;
};

export type getApiOwnerBankAccountsListResponse = (getApiOwnerBankAccountsListResponseSuccess | getApiOwnerBankAccountsListResponseError)

export const getGetApiOwnerBankAccountsListUrl = (id: number,) => {


  

  return `/api/owners/${id}/bank-accounts`
}

export const getApiOwnerBankAccountsList = async (id: number, options?: RequestInit): Promise<getApiOwnerBankAccountsListResponse> => {
  
  return customFetch<getApiOwnerBankAccountsListResponse>(getGetApiOwnerBankAccountsListUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type getApiOwnerListResponse200 = {
  data: GetApiOwnerList200
  status: 200
}

export type getApiOwnerListResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type getApiOwnerListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiOwnerListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}
    
export type getApiOwnerListResponseSuccess = (getApiOwnerListResponse200) & {
  headers: Headers;
};
export type getApiOwnerListResponseError = (getApiOwnerListResponse400 | getApiOwnerListResponse401 | getApiOwnerListResponse403) & {
  headers: Headers;
};

export type getApiOwnerListResponse = (getApiOwnerListResponseSuccess | getApiOwnerListResponseError)

export const getGetApiOwnerListUrl = (params?: GetApiOwnerListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/owners?${stringifiedParams}` : `/api/owners`
}

export const getApiOwnerList = async (params?: GetApiOwnerListParams, options?: RequestInit): Promise<getApiOwnerListResponse> => {
  
  return customFetch<getApiOwnerListResponse>(getGetApiOwnerListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type postApiOwnerCreateResponse204 = {
  data: void
  status: 204
}

export type postApiOwnerCreateResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type postApiOwnerCreateResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type postApiOwnerCreateResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type postApiOwnerCreateResponse409 = {
  data: ConflictErrorResponse
  status: 409
}
    
export type postApiOwnerCreateResponseSuccess = (postApiOwnerCreateResponse204) & {
  headers: Headers;
};
export type postApiOwnerCreateResponseError = (postApiOwnerCreateResponse400 | postApiOwnerCreateResponse401 | postApiOwnerCreateResponse403 | postApiOwnerCreateResponse409) & {
  headers: Headers;
};

export type postApiOwnerCreateResponse = (postApiOwnerCreateResponseSuccess | postApiOwnerCreateResponseError)

export const getPostApiOwnerCreateUrl = () => {


  

  return `/api/owners`
}

export const postApiOwnerCreate = async (createOwnerRequest: CreateOwnerRequest, options?: RequestInit): Promise<postApiOwnerCreateResponse> => {
  
  return customFetch<postApiOwnerCreateResponse>(getPostApiOwnerCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createOwnerRequest,)
  }
);}


export type putApiOwnerUpdateResponse200 = {
  data: OwnerApiResource
  status: 200
}

export type putApiOwnerUpdateResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type putApiOwnerUpdateResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type putApiOwnerUpdateResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type putApiOwnerUpdateResponse409 = {
  data: ConflictErrorResponse
  status: 409
}
    
export type putApiOwnerUpdateResponseSuccess = (putApiOwnerUpdateResponse200) & {
  headers: Headers;
};
export type putApiOwnerUpdateResponseError = (putApiOwnerUpdateResponse400 | putApiOwnerUpdateResponse401 | putApiOwnerUpdateResponse403 | putApiOwnerUpdateResponse409) & {
  headers: Headers;
};

export type putApiOwnerUpdateResponse = (putApiOwnerUpdateResponseSuccess | putApiOwnerUpdateResponseError)

export const getPutApiOwnerUpdateUrl = (id: number,) => {


  

  return `/api/owners/${id}`
}

export const putApiOwnerUpdate = async (id: number,
    updateOwnerRequest: UpdateOwnerRequest, options?: RequestInit): Promise<putApiOwnerUpdateResponse> => {
  
  return customFetch<putApiOwnerUpdateResponse>(getPutApiOwnerUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateOwnerRequest,)
  }
);}


